export default function BethlehemStar({ size = 120 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 500 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ overflow: 'visible' }}
    >
      <defs>
        <radialGradient id="starGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#fffef5" stopOpacity="1" />
          <stop offset="40%" stopColor="#fff8e7" stopOpacity="0.8" />
          <stop offset="70%" stopColor="#ffefc2" stopOpacity="0.4" />
          <stop offset="100%" stopColor="#ffefc2" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="rayGradient" x1="0%" y1="50%" x2="100%" y2="50%">
          <stop offset="0%" stopColor="#fffef5" stopOpacity="0.9" />
          <stop offset="30%" stopColor="#fff8e7" stopOpacity="0.6" />
          <stop offset="60%" stopColor="#ffefc2" stopOpacity="0.3" />
          <stop offset="100%" stopColor="#ffefc2" stopOpacity="0" />
        </linearGradient>
        <filter id="softGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="8" />
        </filter>
        <filter id="rayBlur" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="3" />
        </filter>
      </defs>
      <g transform="translate(250, 250)">
        <circle cx="0" cy="0" r="80" fill="url(#starGlow)" filter="url(#softGlow)" opacity="0.6" />
        {[0, 90, 180, 270].map(angle => (
          <polygon
            key={angle}
            points="0,-8 180,-3 180,3 0,8"
            fill="url(#rayGradient)"
            filter="url(#rayBlur)"
            transform={`rotate(${angle})`}
            opacity="0.8"
          />
        ))}
        {[45, 135, 225, 315].map(angle => (
          <polygon
            key={angle}
            points="0,-5 120,-2 120,2 0,5"
            fill="url(#rayGradient)"
            filter="url(#rayBlur)"
            transform={`rotate(${angle})`}
            opacity="0.6"
          />
        ))}
        <circle cx="0" cy="0" r="35" fill="url(#starGlow)" opacity="0.9" />
        <circle cx="0" cy="0" r="12" fill="#fffef5" />
      </g>
    </svg>
  );
}
